import { Heading, Box, Card, Flex, Button } from "theme-ui";

import { LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";

import { COIN } from "../../strings";

import { DisabledEditableRow, StaticRow } from "../Trove/Editor";
import { LoadingOverlay } from "../LoadingOverlay";
import { Icon } from "../Icon";

import { useStakingView } from "./context/StakingViewContext";
import { StakingGainsAction } from "./StakingGainsAction";
import GetSableBnbLpButton from "./GetSableBnbLpButton";
import SableBnbLpBalanceLabel from "./SableBnbLpBalanceLabel";
import { useStakingContext } from "./context/StakingContext";
import useChain from "../../hooks/useChain";

const select = ({ sableStake, totalStakedSABLE }: LiquityStoreState) => ({
  sableStake,
  totalStakedSABLE
});

export const ReadOnlyStake: React.FC = () => {
  const { changePending, dispatch } = useStakingView();
  const { sableStake, totalStakedSABLE } = useLiquitySelector(select);

  const poolShare = sableStake.stakedSABLE.mulDiv(100, totalStakedSABLE);
  const chain = useChain();
  const currencySymbol = chain.nativeCurrency.symbol;
  const lpSymbol = chain.isStakeLPSupported ? `SABLE-${chain.nativeCurrency.symbol}` : "SABLE";
  const {
    pancakeSwapPool2Data: { lpfeeApr }
  } = useStakingContext();
  return (
    <Card>
      <Heading>
        Staking
        <Button
          onClick={() => dispatch({ type: "startAdjusting" })}
          sx={{
            bg: "white",
            color: "#000000",
            border: "1px solid #E5E7EB",
            borderRadius: "8px",
            px: 2,
            py: 1,
            fontSize: 1,
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            gap: 1,
            cursor: "pointer",
            transition: "all 0.2s",
            ":hover": {
              bg: "#F9FAFB",
              borderColor: "#D1D5DB",
              transform: "translateY(-1px)",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
            }
          }}
        >
          <Icon name="pen" size="sm" />
          Adjust
        </Button>
      </Heading>

      <Box sx={{ p: [2, 3], display: "flex", flexDirection: "column", height: "100%" }}>
        <Box sx={{ flex: 1 }}>
        <DisabledEditableRow
          label="Stake"
          inputId="stake-sable"
          amount={sableStake.stakedSABLE.prettify()}
          unit={lpSymbol}
          trailingLabel={<SableBnbLpBalanceLabel />}
        />

        <StaticRow
          label="Pool share"
          inputId="stake-share"
          amount={poolShare.prettify(4)}
          unit="%"
        />

        <StaticRow
          label="Redemption gain"
          inputId="stake-gain-eth"
          amount={sableStake.collateralGain.prettify(4)}
          color={sableStake.collateralGain.nonZero && "success"}
          unit={currencySymbol}
        />

        <StaticRow
          label="Issuance gain"
          inputId="stake-gain-usds"
          amount={sableStake.usdsGain.prettify()}
          color={sableStake.usdsGain.nonZero && "success"}
          unit={COIN}
        />
        {chain.isStakeLPSupported && (
          <StaticRow
            label="LP fee APR"
            inputId="lp-fee-apr"
            amount={lpfeeApr?.toFixed(2) || "-"}
            color="success"
            unit="%"
          />
        )}
        </Box>

        <Flex variant="layout.actions" sx={{ flexWrap: "nowrap", gap: 2 }}>
          <GetSableBnbLpButton />
          <StakingGainsAction />
        </Flex>
      </Box>

      {changePending && <LoadingOverlay />}
    </Card>
  );
};
